import { render, staticRenderFns } from "./authorize.vue?vue&type=template&id=98380622&scoped=true"
import script from "./authorize.vue?vue&type=script&lang=js"
export * from "./authorize.vue?vue&type=script&lang=js"
import style0 from "./authorize.vue?vue&type=style&index=0&id=98380622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98380622",
  null
  
)

export default component.exports